import React, { useEffect } from 'react';

export const useOnClickOutside = (ref: React.RefObject<HTMLElement>, handler: any) => {
    useEffect(() => {
        const listener = (event: any) => {
            const target = event.target as Node;
            if (!target || !target.isConnected) {
                return;
            }
            const isOutside = Array.isArray(ref)
                ? ref.every((r) => r.current && !r.current.contains(target))
                : ref.current && !ref.current.contains(target);
            if (isOutside) {
                handler(event);
            }
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};
